/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useEffect} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../../_metronic/layout/core'
import {getCertificateData} from '../redux/CertificateCRUD'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import * as certificate from '../redux/CertificateRedux'
import ListCertificateData from './ListCertificateData'
import {RootState} from '../../../../setup'

const ListPage: FC = () => {
  const dispatch = useDispatch()
  const isAuthorized = useSelector<RootState>(({auth}) => auth.role, shallowEqual)

  const callCertificateData = async () => {
    try {
      let certificateData = await getCertificateData(0, 50, isAuthorized)
      if (certificateData.data) {
        await dispatch(certificate.actions.setCertificateLoading(true))
        // once certificate data set then loading will automatically off using saga middleware
        await dispatch(certificate.actions.setCertificateData(certificateData.data.docs))
        await dispatch(certificate.actions.setCertificateDataTotal(certificateData.data.totalDocs))
      }
    } catch (e) {
      console.log('!!!!Error', e)
    }
  }

  useEffect(() => {
    callCertificateData()
  }, [])

  return (
    <div>
      <ListCertificateData />
    </div>
  )
}

const ListWraaper: FC = () => {
  const intl = useIntl()

  return (
    <div>
      <PageTitle
        breadcrumbs={[
          {
            title: 'list',
            path: '/certificate/list',
            isActive: true,
            isSeparator: false,
          },
          {
            title: 'list',
            path: '/certificate/list',
            isActive: true,
            isSeparator: true,
          },
        ]}
      >
        {intl.formatMessage({id: 'MENU.CERTIFICATE'})}
      </PageTitle>
      <ListPage />
    </div>
  )
}

export {ListWraaper}
